/*
  <rayon-produits> — charge la sélection de produits d'un rayon depuis une page
  de type ou de marque Shopify (/collections/types?q=…) via l'API de rendu des
  sections (section interne « rayon-produits-grille »).
  Chargement différé : la requête part quand le rayon approche de l'écran.
*/
if (!customElements.get('rayon-produits')) {
  customElements.define(
    'rayon-produits',
    class RayonProduits extends HTMLElement {
      connectedCallback() {
        if (this.dataset.charge) return;
        // Téléphone : les rayons sont repliés (accordéon), donc invisibles pour
        // l'observateur. On charge quand même peu après l'affichage, pour que
        // le nombre de produits apparaisse à côté de chaque titre.
        if (window.matchMedia('(max-width: 749px)').matches) {
          const lancer = () => this.charger();
          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(lancer, { timeout: 1500 });
          } else {
            setTimeout(lancer, 300);
          }
          return;
        }
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entrees) => {
              if (entrees.some((e) => e.isIntersecting)) {
                this.observer.disconnect();
                this.charger();
              }
            },
            { rootMargin: '400px 0px' }
          );
          this.observer.observe(this);
        } else {
          this.charger();
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      async charger() {
        this.dataset.charge = 'true';
        const { url, ordre, limite, rayon } = this.dataset;
        try {
          const reponse = await fetch(url, { credentials: 'same-origin' });
          if (!reponse.ok) throw new Error(reponse.status);
          const html = await reponse.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grille = doc.querySelector('.rayon-grille');
          const modele = grille && grille.querySelector(`template[data-ordre="${ordre}"]`);
          if (!modele) throw new Error('grille absente');

          const conteneur = document.createElement('div');
          conteneur.innerHTML = modele.innerHTML.split('__RAYON__').join(rayon);

          const max = parseInt(limite, 10) || 8;
          const items = conteneur.querySelectorAll('.slider__slide');
          items.forEach((item, i) => {
            if (i >= max) item.remove();
          });
          const affiches = Math.min(items.length, max);
          const total = conteneur.querySelector('.slider-counter--total');
          if (total) total.textContent = affiches;

          if (affiches === 0) {
            this.replaceChildren();
            this.hidden = true;
            return;
          }

          const compte = parseInt(grille.dataset.total, 10);
          const section = this.closest('.rayon');
          if (section && compte > 0) {
            section.querySelectorAll('[data-rayon-compte]').forEach((el) => {
              el.textContent = ` (${compte})`;
            });
            section.querySelectorAll('[data-rayon-nb]').forEach((el) => {
              el.textContent = compte;
            });
          }

          this.classList.remove('rayon__chargement');
          this.replaceChildren(...conteneur.childNodes);
        } catch (erreur) {
          // En cas d'échec, on retire le squelette : le lien « Voir tout » reste utilisable.
          this.replaceChildren();
          this.hidden = true;
        }
      }
    }
  );
}
